import { Helmet } from 'react-helmet';
import { useIntl } from 'react-intl';

// COMPONENTS
import { CanOrNotFound } from 'permissions';
import GeofencingCard from './cards/geofencing.component';

// STYLES
import { SettingsPageContent } from 'styles/settings';

// CONSTANTS
import { DotAppRoute, FleetSettingsSideMenuItem, UserPermission } from 'constants/common';

const Geofencing = () => {
  const intl = useIntl();

  return (
    <CanOrNotFound I={UserPermission.VIEW} a={DotAppRoute.SETTINGS} field={FleetSettingsSideMenuItem.GEOFENCING}>
      <SettingsPageContent>
        <Helmet>
          <title>
            {intl.formatMessage({
              id: 'views.Settings.helmetTitle',
            })}
          </title>
          <meta
            name="settings"
            content={intl.formatMessage({
              id: 'views.Settings.helmetDescription',
            })}
          />
        </Helmet>
        <GeofencingCard />
      </SettingsPageContent>
    </CanOrNotFound>
  );
};

export default Geofencing;
